<template>
  <div class="pattern-wrap">
    <div
      :style="{ background: baseColor.backgroundColor }"
      class="base-color"
      id="base-color"
    >
    </div>
    <b-popover
      target="base-color"
      triggers="click blur"
      placement="left"
      ref="basePopover"
    >
      <ColorPicker
        v-on-clickaway="close"
        :colors="colorsCategories.trimColors"
        @onSelectColor="onSelectBaseColor"
      />
    </b-popover>
  </div>
</template>

<script>
import ColorPicker from '@/components/common/ColorPicker.vue';
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'PatternC',
  mixins: [clickaway],
  components: {
    ColorPicker,
  },
  data () {
    return {
      baseColor: {
        backgroundColor: null
      },
    };
  },
  mounted () {
    this.changeBaseColor();
  },
  computed: {
    baseTrimsColor () {
      return this.$store.getters['design/getBaseTrimsColor'];
    },
    colorsCategories () {
      return this.$store.getters['elements/getColorsCategories'];
    },
  },
  watch: {
    baseTrimsColor () {
      this.changeBaseColor();
    },
  },
  methods: {
    basePopoverOnOpen () {
      this.$refs.basePopover.$emit('open');
    },
    changeBaseColor () {
      this.baseColor.backgroundColor = this.baseTrimsColor.hex;
    },
    onSelectBaseColor (color) {
      this.$store.commit('design/setBaseTrimColor', { color });
      this.$refs.basePopover.$emit('close');
    },
    close () {
      this.$refs.basePopover.$emit('close');
    }
  }
};
</script>

<style scoped>
.pattern-wrap {
  outline: 1px solid black;
  width: 160px;
  height: 160px;
}
.base-color {
  width: 160px;
  height: 160px;
  background-color: #ffffff;
}
</style>
